import { render } from "./BaseMenu.vue?vue&type=template&id=08bfafc6&scoped=true"
import script from "./BaseMenu.vue?vue&type=script&lang=js"
export * from "./BaseMenu.vue?vue&type=script&lang=js"

import "./BaseMenu.vue?vue&type=style&index=0&id=08bfafc6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-08bfafc6"

export default script